import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Tooltip as Tooltip$1 } from '@mui/material';
var _excluded = ["disabled"]; // not passed down to the tooltip.

/* eslint-disable @typescript-eslint/no-unused-vars */

var Tooltip = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  _ref.disabled;

  var rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Tooltip$1, _extends({}, rest, {
    ref: ref
  }));
});
Tooltip.displayName = 'Tooltip';
export { Tooltip };